import { OnboardingPepConnectionFormType } from 'modules/onboarding/common/forms/onboardingPepConnectionForm';
import { useClientPepConnection } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const usePepConnection = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { initialValues, onSubmit, submitLoading } =
    useClientPepConnection(data);

  const handleSubmit = async (values: OnboardingPepConnectionFormType) => {
    if (values) {
      await onSubmit(values);
      goToNext();
    }
  };

  return {
    onSubmit: handleSubmit,
    goToBack,
    initialValues,
    submitLoading,
  };
};
